export { default as avatar } from "assets/images/avatar.png";
export { default as friendAvatar } from "assets/images/avatars/dan.jpg";
export { default as friendAvatar2 } from "assets/images/avatars/jenna.png";
export { default as logo } from "assets/images/momeento.png";
export { default as welcomeSVG } from "assets/images/welcome.svg";
export { default as placeHolderImg } from "assets/images/placeholder.png";
export { default as deletedPNG } from "assets/images/deleted.png";
export { default as blockedPNG } from "assets/images/blocked.png";
export { default as profileBG } from "assets/images/profileBG.png";

export { default as playstore } from "assets/images/playstore.svg";
export { default as appstore } from "assets/images/AppStore.svg";
export { default as web } from "assets/images/web.png";

// demo communities
import demo01 from "assets/images/demo/communities/1.jpeg";
import demo02 from "assets/images/demo/communities/2.jpeg";
import demo03 from "assets/images/demo/communities/3.jpeg";
import demo04 from "assets/images/demo/communities/4.jpg";
import demo05 from "assets/images/demo/communities/5.jpeg";
import demo06 from "assets/images/demo/communities/6.jpeg";
import demo07 from "assets/images/demo/communities/7.jpeg";
import demo08 from "assets/images/demo/communities/8.jpeg";
import demo09 from "assets/images/demo/communities/9.jpeg";
import demo10 from "assets/images/demo/communities/10.jpeg";
import demo11 from "assets/images/demo/communities/11.jpeg";
import demo12 from "assets/images/demo/communities/12.jpeg";
import demo13 from "assets/images/demo/communities/13.jpg";
import demo14 from "assets/images/demo/communities/14.jpeg";
import demo15 from "assets/images/demo/communities/15.jpeg";
import demo16 from "assets/images/demo/communities/16.jpeg";
import demo17 from "assets/images/demo/communities/17.jpeg";
import demo18 from "assets/images/demo/communities/18.jpeg";
import demo19 from "assets/images/demo/communities/19.jpeg";
import demo20 from "assets/images/demo/communities/20.jpeg";

export const demoCommunityListingImg = [
    demo01,
    demo02,
    demo03,
    demo04,
    demo05,
    demo06,
    demo07,
    demo08,
    demo09,
    demo10,
    demo11,
    demo12,
    demo13,
    demo14,
    demo15,
    demo16,
    demo17,
    demo18,
    demo19,
    demo20
];
